import { StepEnum } from '../../../../../components-library/checkout/CheckoutSteps';

export default {
  steps: {
    [StepEnum.OrderConfirmation]: 'Revisar pedido',
    [StepEnum.OrderPayment]: 'Pago',
  },
};
